"use client"

import { useAppRouter } from "@/hooks/app/useAppRouter"
import { useCurrentPrice } from "@/hooks/product_no_design/useCurrentPrice"
import { useProductName } from "@/hooks/product_no_design/useProductName"
import useSelectedAspect from "@/hooks/product_no_design/useSelectedAspect"
import { useSelectedVariant } from "@/hooks/product_no_design/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { useStoreData } from "@/hooks/store/useStoreData"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Button } from "antd"
import { useParams } from "next/navigation"

const ProductAddToCartButton = () => {
  const dispatch = useAppDispatch()
  const params = useParams()
  const router = useAppRouter()
  const productName = useProductName()
  const { store } = useStoreData()
  const { price } = useCurrentPrice()
  const quantity = useAppSelector(state => state.product.quantity)
  const p_type = useAppSelector(state => state.product.product_no_design.data.p_type)
  const productId = useAppSelector(state => state.product.product_no_design.data.id)
  const selectedVaraiant = useSelectedVariant()
  const { aspect } = useSelectedAspect()
  const defaultImage = useAppSelector(state => state.product.product_no_design.data.default_image)
  const variants: any = useAppSelector(state => state.product.product_no_design.data.variants) || []

  return (
    <Button
      block
      aria-label="Add product to cart"
      htmlType="button"
      size="large"
      type="primary"
      style={{ height: "5rem" }}
      onClick={() => {
        dispatch(productActions.addProductToCart({
          productId: productId,
          productName: productName,
          store_id: store.store_id,
          price: price,
          compare_at_price: 0,
          quantity: quantity,
          preview: ((selectedVaraiant?.images || [])[0] || {})[aspect] || defaultImage,
          variant: p_type === 'digital' ? selectedVaraiant || variants[0] : selectedVaraiant,
          products: [],
          p_type: p_type,
          noDesign: true,
        }))
        router.push('/cart')
      }}
    >
      ADD TO CART
    </Button>
  )
}

export default ProductAddToCartButton